import "./PageDescriptionBar.css";

/**
 * PageDescriptionBar
 *
 * Renders a horizontal legend strip that lists status indicators and actions
 * available on the page so users know what each control does at a glance.
 *
 * items: Array of objects – one of the following shapes:
 *   { type: "badge",     badge: "active"|"inactive"|"warning", text: string, note?: string }
 *   { type: "icon",      icon: string (emoji/char),            text: string, note?: string }
 *   { type: "img",       src: string (imported image),         text: string, note?: string }
 *   { type: "separator" }
 */
const PageDescriptionBar = ({ items = [], title = "Status & Actions:" }) => {
  if (!items.length) return null;

  return (
    <div className="pdb-bar mb-3">
      <div className="pdb-legend">
        <span className="pdb-title">{title}</span>
        {items.map((item, idx) => {
          if (item.type === "separator") {
            return <span key={idx} className="pdb-separator" />;
          }
          return (
            <span key={idx} className="pdb-item">
              {item.type === "badge" && (
                <span className={`pdb-badge pdb-badge--${item.badge}`} />
              )}
              {item.type === "icon" && (
                <span className="pdb-icon">{item.icon}</span>
              )}
              {item.type === "img" && (
                <img src={item.src} alt={item.text} className="pdb-img-icon" />
              )}
              <span className="pdb-text">{item.text}</span>
              {item.note && (
                <span className="pdb-note">({item.note})</span>
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default PageDescriptionBar;
